/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Downloads_Nopublicreleases2Inputs */

const id_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada rilis publik ditemukan.`)
};

const ms_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada keluaran awam ditemui.`)
};

const da_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen offentlige udgivelser fundet.`)
};

const de_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine öffentlichen Veröffentlichungen gefunden.`)
};

const en_us2_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No public releases found.`)
};

const es_es2_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron lanzamientos públicos.`)
};

const es_mx2_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron lanzamientos públicos.`)
};

const fil_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang pampublikong release.`)
};

const fr_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune version publique trouvée.`)
};

const it_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna versione pubblica trovata.`)
};

const hu_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található nyilvános kiadás.`)
};

const nl_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen openbare releases gevonden.`)
};

const no_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen offentlige utgivelser funnet.`)
};

const pl_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono publicznych wydań.`)
};

const pt_br2_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum lançamento público encontrado.`)
};

const pt_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum lançamento público encontrado.`)
};

const ro_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit lansări publice.`)
};

const fi_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkisia julkaisuja ei löytynyt.`)
};

const sv_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga publika releaser hittades.`)
};

const vi_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bản phát hành công khai.`)
};

const tr_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herkese açık sürüm bulunamadı.`)
};

const cs_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyla nalezena žádná veřejná vydání.`)
};

const bg_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени публични издания.`)
};

const ru_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публичные релизы не найдены.`)
};

const uk_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публічних релізів не знайдено.`)
};

const ar_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على إصدارات عامة.`)
};

const hi_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई सार्वजनिक रिलीज़ नहीं मिली।`)
};

const th_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบการวางจำหน่ายสาธารณะ`)
};

const ja_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公開リリースが見つかりません。`)
};

const zh_cn2_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到公开版本。`)
};

const zh_hant1_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到公開版本。`)
};

const ko_misc_downloads_nopublicreleases2 = /** @type {(inputs: Misc_Downloads_Nopublicreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공개 릴리스가 없습니다.`)
};

/**
* | output |
* | --- |
* | "No public releases found." |
*
* @param {Misc_Downloads_Nopublicreleases2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_downloads_nopublicreleases2 = /** @type {((inputs?: Misc_Downloads_Nopublicreleases2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Downloads_Nopublicreleases2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_downloads_nopublicreleases2(inputs)
	if (locale === "ms") return ms_misc_downloads_nopublicreleases2(inputs)
	if (locale === "da") return da_misc_downloads_nopublicreleases2(inputs)
	if (locale === "de") return de_misc_downloads_nopublicreleases2(inputs)
	if (locale === "en-US") return en_us2_misc_downloads_nopublicreleases2(inputs)
	if (locale === "es-ES") return es_es2_misc_downloads_nopublicreleases2(inputs)
	if (locale === "es-MX") return es_mx2_misc_downloads_nopublicreleases2(inputs)
	if (locale === "fil") return fil_misc_downloads_nopublicreleases2(inputs)
	if (locale === "fr") return fr_misc_downloads_nopublicreleases2(inputs)
	if (locale === "it") return it_misc_downloads_nopublicreleases2(inputs)
	if (locale === "hu") return hu_misc_downloads_nopublicreleases2(inputs)
	if (locale === "nl") return nl_misc_downloads_nopublicreleases2(inputs)
	if (locale === "no") return no_misc_downloads_nopublicreleases2(inputs)
	if (locale === "pl") return pl_misc_downloads_nopublicreleases2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_downloads_nopublicreleases2(inputs)
	if (locale === "pt") return pt_misc_downloads_nopublicreleases2(inputs)
	if (locale === "ro") return ro_misc_downloads_nopublicreleases2(inputs)
	if (locale === "fi") return fi_misc_downloads_nopublicreleases2(inputs)
	if (locale === "sv") return sv_misc_downloads_nopublicreleases2(inputs)
	if (locale === "vi") return vi_misc_downloads_nopublicreleases2(inputs)
	if (locale === "tr") return tr_misc_downloads_nopublicreleases2(inputs)
	if (locale === "cs") return cs_misc_downloads_nopublicreleases2(inputs)
	if (locale === "bg") return bg_misc_downloads_nopublicreleases2(inputs)
	if (locale === "ru") return ru_misc_downloads_nopublicreleases2(inputs)
	if (locale === "uk") return uk_misc_downloads_nopublicreleases2(inputs)
	if (locale === "ar") return ar_misc_downloads_nopublicreleases2(inputs)
	if (locale === "hi") return hi_misc_downloads_nopublicreleases2(inputs)
	if (locale === "th") return th_misc_downloads_nopublicreleases2(inputs)
	if (locale === "ja") return ja_misc_downloads_nopublicreleases2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_downloads_nopublicreleases2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_downloads_nopublicreleases2(inputs)
	return ko_misc_downloads_nopublicreleases2(inputs)
});
export { misc_downloads_nopublicreleases2 as "misc.downloads.noPublicReleases" }